import { createZustandStore } from '../../../zustand';

import { DEFAULT_SCAN_TYPE } from '../../inbound';

import { INewTransferStore } from './types';

/**
 * This is to track the mutation key for scanning a pod or tray code
 * for inventory transfer.
 */
export const useNewTransfer = createZustandStore<INewTransferStore>()(
  (set) => ({
    isPodScan: false,
    isCancelFlow: false,
    errorResponse: null,
    updateErrorResponse: (errorResponse) => set(() => ({ errorResponse })),
    updateIsCancelFlow: (isCancelFlow: boolean) =>
      set(() => ({ isCancelFlow })),
    inventoryTransferId: '',
    updateInventoryTransferId: (id: string) =>
      set(() => ({ inventoryTransferId: id })),
    updateIsPodScan: (isPodScan) => set(() => ({ isPodScan })),
    currentScanStep: 'scan-tray-or-pod',
    transferTrayFilter: 'IN_PROGRESS',
    isTrayListScanCompleted: false,
    setIsTrayListScanCompleted: (isCompleted) =>
      set(() => ({ isTrayListScanCompleted: isCompleted })),
    updateTransferTrayFilter: (transferTrayFilter) =>
      set(() => ({ transferTrayFilter })),
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    scanType: DEFAULT_SCAN_TYPE,
    updateScanType: (scanType) => set(() => ({ scanType })),
    isScannerReadingData: false,
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    transferDetails: null,
    updateTransferDetails: (transferDetails) =>
      set(() => ({ transferDetails })),
    resetStore: () =>
      set({
        currentScanStep: 'scan-tray-or-pod',
        scanType: DEFAULT_SCAN_TYPE,
        isScannerReadingData: true,
        isPodScan: false,
        isCancelFlow: false,
        transferDetails: null,
        transferTrayFilter: 'IN_PROGRESS',
        errorResponse: null,
      }),
  })
);
